import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';


/* global customElements */
class CustomHandlerGrid extends BaseComponent {
	
	static get properties() {
		return {
		};
	}
	
	constructor() {
		super();
	
		var customHandlerGrid = this;
		setTimeout(function(){
			customHandlerGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var customHandlerGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},				
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_CUSTOM_DATA_HANDLER:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_CUSTOM_DATA_HANDLER:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'mapping',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_CUSTOM_DATA_HANDLER:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:list', ' Mapping')						
					],
					listeners: {
						click: function() {
							actionMapping(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'toggleStatus',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_CUSTOM_DATA_HANDLER:UPDATE_STATUS'],
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Toggle Status')						
					],
					listeners: {
						click: function() {
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}					
				},				
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',						
							theme: 'primary',
							itemid: 'test',
							disabled: true,
							'class': 'spacer-toolbar-item',
							style: 'float: right;',
							permissions: ['ADMIN_CUSTOM_DATA_HANDLER:READ'],
							children:[
								ElementUtil.makeIcon('vaadin:play', ' Test')
							],
							listeners: {
								click: function() {
									actionTest(grid.selectedItems[0]);
								}
							}
						}
					]
				}
			]
		});		
			
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'customHandlerId',
					header: 'Handler Id',
					width: '7em'
				},
				{						
					path: 'name',
					header: 'Name',
					width: '7em'
				},				
				{						
					path: 'formatDescription',
					header: 'Description',
					width: '9em'
				},
				{						
					path: 'dataTypeDescription',
					header: 'Data Type',
					width: '7em',
					'text-align': 'center'
				},
				{						
					path: 'readerTypeDescription',
					header: 'Reader Type',
					width: '7em'
				},
				{						
					path: 'visiblityType',
					header: 'Visibilty Type',
					width: '7em',
					'text-align': 'center'
				},					
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'mapping').disabled = false;						
						ElementUtil.query(toolbar, 'test').disabled = false;	
						ElementUtil.query(toolbar, 'toggleStatus').disabled = false;	
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'mapping').disabled = true;
						ElementUtil.query(toolbar, 'test').disabled = true;	
						ElementUtil.query(toolbar, 'toggleStatus').disabled = true;	
					}
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		customHandlerGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			
			var activeStatus = ElementUtil.query(toolbar, 'status');
			
			var paging = {
				status: activeStatus.value
			};
			
			var loadMask = grid.showLoading();			
			DataManagementService.getCustomDataHandlerService().getCustomDataHandlers(paging).then(function(dataHandlers){
				loadMask.remove();
				grid.activeItem = null;
				grid.items = dataHandlers.data;	
			});			
		};
		actionRefresh();
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: 620,
				listeners: {
					ready: function() {						
						addEditWin.show();
											
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'name',
											label: 'Name',											
											required: true,
											maxLength: 120											
										},
										{
											tag: 'vaadin-text-field',										
											name: 'formatDescription',
											label: 'Description',											
											required: true,
											maxLength: 1024											
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'dataTypeCB',
											name: 'dataType',
											label: 'Data Type',
											'item-value-path': 'code',
											'item-label-path': 'description',																					
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('DataType').then(function (data) {
													var mappable = [];
													data.forEach(function(item){
														if (item.mappable) {
															mappable.push(item);
														}
													});
													
													combo.items = mappable;
													combo.required = true;
												});
											},
											placeHolder: 'Select'
										},										
										{
											tag: 'vaadin-combo-box',
											itemid: 'readerTypeCB',
											name: 'readerType',
											label: 'Reader Type',
											'item-value-path': 'code',
											'item-label-path': 'description',										
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('CustomDataReaderType').then(function (data) {																									
													combo.items = data;
													combo.required = true;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'visiblityTypeCB',
											name: 'visiblityType',
											label: 'Visibility Type',
											'item-value-path': 'code',
											'item-label-path': 'desc',											
											required: true,
											postinit: function (combo) {
												combo.items = [
													{
														code: 'C',
														desc: 'Company'
													}, {
														code: 'G',
														desc: 'Global'
													}
												];
												combo.value = 'C';
											},
											placeHolder: 'Select'
										},
										{
											tag: 'div',
											colspan: 2,
											style: 'font-weight: 600; margin-top: 8px;',
											innerHTML: 'Import Scripts (BeanShell)'
										},
										{
											tag: 'div',
											colspan: 2,
											style: 'font-size: 0.85em; color: var(--lumo-secondary-text-color); margin-bottom: 4px;',
											trustedInnerHTML: true,
											innerHTML: 'Shared <code>context</code> map is available from pre through post. Also bound: processingContext, scriptBridge, companyServiceProxy, coreServiceProxy, currentUser. Pre-record also has rawData and record. Custom Import <strong>Test</strong> runs pre, pre-record, and post (still no save/validation).'
										},
										{
											tag: 'vaadin-text-area',
											name: 'preScript',
											label: 'Pre Script',
											colspan: 2,
											style: 'width: 100%;',
											maxlength: 100000
										},
										{
											tag: 'vaadin-text-area',
											name: 'preRecordScript',
											label: 'Pre-Record Script',
											colspan: 2,
											style: 'width: 100%;',
											maxlength: 100000
										},
										{
											tag: 'vaadin-text-area',
											name: 'postScript',
											label: 'Post Script',
											colspan: 2,
											style: 'width: 100%;',
											maxlength: 100000
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
																	
															formPanel.submitForm({
																preSubmit: function (data) {														
																	return data;
																},
																actualCall: function (data) {
																	if (record) {
																		data.customHandlerId = record.customHandlerId;
																		
																		data.fields = record.fields;
																		data.skipConditions = record.skipConditions;
																		// scripts come from the form fields (preScript / preRecordScript / postScript)
																	}
																	return DataManagementService.getCustomDataHandlerService().saveCustomHandler(data, (record ? true : false));
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Custom Data Handler', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						if (record) {
							formPanel.load(record);
						}
						
					}
				}
			});			
		};
		
		var actionUpdateStatus = function(record) {
			
			var loadMask = grid.showLoading('Updating...');	
			if (record.activeStatus === 'I') {
				DataManagementService.getCustomDataHandlerService().activate(record.customHandlerId).then(function(data) {
					loadMask.remove();
					window.DL.MessageUtil.showToast('Success', 'Activated: ' + record.name, {
						theme: 'success'
					});
					actionRefresh();
				});
			} else {
				DataManagementService.getCustomDataHandlerService().inactivate(record.customHandlerId).then(function(data) {
					loadMask.remove();					
					window.DL.MessageUtil.showToast('Success', 'Inactivated: ' + record.name, {
						theme: 'success'
					});
					actionRefresh();
				});
			}
			
			
		};	
		
		var actionMapping = function(record) {
	
			var mappingWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Edit Mapping: ' + record.name + " - " + record.dataTypeDescription + " - " + record.readerTypeDescription,
				icon: 'vaadin:list',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						mappingWin.show();
						
						var fieldMappings = [];
						var skipConditions = [];
						
						var mappingToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-button',
									itemid: 'add',
									theme: 'primary',
									'class': 'spacer-toolbar-item',
									children: [
										ElementUtil.makeIcon('vaadin:plus', ' Add')
									],
									listeners: {
										click: function () {
											actionAddEditMapping();
										}
									}
								},
								{
									tag: 'vaadin-button',
									itemid: 'edit',
									disabled: true,
									'class': 'spacer-toolbar-item',
									children: [
										ElementUtil.makeIcon('vaadin:edit', ' Edit')
									],
									listeners: {
										click: function () {
											actionAddEditMapping(mappingGrid.selectedItems[0]);
										}
									}
								},
								{
									tag: 'span',
									innerHTML: '|'
								},
								{
									tag: 'vaadin-button',
									itemid: 'import',									
									'class': 'spacer-toolbar-item',
									children: [
										ElementUtil.makeIcon('vaadin:upload', ' Import Fields')
									],
									listeners: {
										click: function () {
											actionImportFieldMappings();
										}
									}
								},								
								{
									tag: 'vaadin-button',
									itemid: 'skip',							
									'class': 'spacer-toolbar-item',
									children: [
										ElementUtil.makeIcon('vaadin:minus', ' Skip Conditions')
									],
									listeners: {
										click: function () {
											actionSkipConditions();
										}
									}
								},
								{
									tag: 'div',
									style: 'float: right;',
									children: [
										{
											tag: 'vaadin-button',
											theme: 'error primary',
											itemid: 'remove',
											disabled: true,
											'class': 'spacer-toolbar-item',
											style: 'float: right;',
											children: [
												ElementUtil.makeIcon('vaadin:trash', ' Remove')
											],
											listeners: {
												click: function () {
													actionRemoveFieldMapping(mappingGrid.selectedItems[0]);
												}
											}
										}
									]
								}
							]
						});

						var mappingGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},
							children: [
								{
									path: 'mapField',
									header: 'Map Field',
									width: '7em'
								},
								{
									path: 'dataField',
									header: 'Data Field',
									width: '7em'
								},
								{
									path: 'multipleMapFields',
									header: 'Multi-Field Maps',
									width: '9em',
									renderer: function (root, column, rowData) {								
										if (rowData.item.multipleMapFields) {
											root.innerHTML = rowData.item.multipleMapFields.join(', ');
										} else {
											root.innerHTML = '';
										}																			
									
									}
								},
								{
									path: 'transforms',
									header: 'Transforms',
									width: '7em',
									renderer: function (root, column, rowData) {										
										if (rowData.item.transforms) {
											rowData.item.transforms.sort(function(a, b){
												return (a.orderId || 0) - (b.orderId || 0);
											});
											
											var transformsView = [];
											rowData.item.transforms.forEach(function(item){
												transformsView.push(resolveTransformDescription(item.transform));
											});

											root.innerHTML = transformsView.join(', ');
										} else {
											root.innerHTML = '';
										}
									}
								},
								{
									path: 'matchers',
									header: 'Matchers',
									width: '7em',
									renderer: function (root, column, rowData) {
										if (rowData.item.matchers) {											
											root.innerHTML = rowData.item.matchers.length + ' Matchers defined' ;
										} else {
											root.innerHTML = '';
										}
									}
								},
								{
									path: 'note',
									header: 'Note (temporary)',
									width: '9em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									mappingGrid.selectedItems = item ? [item] : [];
									if (mappingGrid.selectedItems.length > 0) {
										ElementUtil.query(mappingToolbar, 'edit').disabled = false;
										ElementUtil.query(mappingToolbar, 'remove').disabled = false;
									} else {
										ElementUtil.query(mappingToolbar, 'edit').disabled = true;
										ElementUtil.query(mappingToolbar, 'remove').disabled = true;										
									}
								}
							}
						});												
						
						var mappingFooterToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'footer',
							theme: 'spacing',
							children: [
								{
									tag: 'div',
									style: 'text-align: center;',									
									defaults: {
										tag: 'vaadin-button'
									},
									children: [
										{
											theme: 'primary',
											children: [
												ElementUtil.makeIcon('vaadin:database', ' Save')
											],
											listeners: {
												click: function () {
													actionSaveMapping();
												}
											}
										},
										{
											theme: 'tertiary',
											innerHTML: 'Cancel',
											style: 'margin-left: 10px;',
											listeners: {
												click: function () {
													mappingWin.close();
												}
											}
										}
									]
								}
							]
						});
				
						var flexLayoutMapping = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								mappingToolbar,
								mappingGrid,
								mappingFooterToolbar
							]
						});
						
						mappingWin.addToContentElement(flexLayoutMapping);

						var transformDescriptionById = {};
						var resolveTransformDescription = function(transformId) {
							if (!transformId) {
								return '';
							}
							var catalogEntry = transformDescriptionById[transformId];
							return catalogEntry && catalogEntry.description
								? catalogEntry.description
								: transformId;
						};
						
						var actionRefreshFields = function() {
							mappingGrid.activeItem = null;
							mappingGrid.items = fieldMappings.slice();							
						};

						DataManagementService.getCustomDataHandlerService().getTransforms().then(function(transformCatalog) {
							(transformCatalog || []).forEach(function(entry) {
								if (entry && entry.transformId) {
									transformDescriptionById[entry.transformId] = entry;
								}
							});
							actionRefreshFields();
						});
						
						var actionAddEditMapping = function(fieldRecord) {
							//pop up  form
							var addEditMappingWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: (fieldRecord ? 'Edit' : 'Add') + ' Mapping',
								icon: 'vaadin:edit',
								width: .70,
								height: .70,
								listeners: {
									ready: function() {											
										addEditMappingWin.show();
										
										var transforms = [];
										var matchers = [];
										
										var transformGrid = ElementUtil.create({
											tag: 'vaadin-grid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},
											children: [
												{
													path: 'transform',
													header: 'Transform',
													width: '12em',
													renderer: function (root, column, rowData) {
														root.textContent = resolveTransformDescription(rowData.item.transform);
													}
												},
												{
													path: 'transformOption',
													header: 'Option',
													width: '9em'
												},
												{
													path: 'orderId',
													header: 'order Id',
													width: '9em'
												}
											],
											listeners: {
												'active-item-changed': function (event) {
													const item = event.detail.value;
													transformGrid.selectedItems = item ? [item] : [];
													if (formPanel) {
														if (transformGrid.selectedItems.length > 0) {
															ElementUtil.query(formPanel, 'editTransform').disabled = false;
															ElementUtil.query(formPanel, 'removeTransform').disabled = false;
														} else {
															ElementUtil.query(formPanel, 'editTransform').disabled = true;
															ElementUtil.query(formPanel, 'removeTransform').disabled = true;
														}
													}
												}
											}
										});
										
										var matcherGrid = ElementUtil.create({
											tag: 'vaadin-grid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},
											children: [
												{
													path: 'sourceValue',
													header: 'Source Value',
													width: '9em'
												},
												{
													path: 'matchType',
													header: 'Match Type',
													width: '9em'
												},
												{
													path: 'newValue',
													header: 'New Value',
													width: '9em'
												}
											],
											listeners: {
												'active-item-changed': function (event) {
													const item = event.detail.value;
													matcherGrid.selectedItems = item ? [item] : [];
													
													if (formPanel) {
														if (matcherGrid.selectedItems.length > 0) {
															ElementUtil.query(formPanel, 'editMatcher').disabled = false;
															ElementUtil.query(formPanel, 'removeMatcher').disabled = false;
														} else {
															ElementUtil.query(formPanel, 'editMatcher').disabled = true;
															ElementUtil.query(formPanel, 'removeMatcher').disabled = true;
														}
													}
												}
											}
										});
										
										var formPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-text-field',
															name: 'mapField',
															label: 'Map Field',
															required: true,
															maxLength: 255
														},
														{
															tag: 'vaadin-combo-box',
															itemid: 'dataFieldCB',
															name: 'dataField',
															label: 'Data Field',
															'item-value-path': 'fieldPath',
															'item-label-path': 'name',															
															postinit: function (combo) {
																DataManagementService.getCustomDataHandlerService().getMetaModel(record.dataType).then(function(model){																	
																	model.dataField.sort(function(a, b){
																		return a.name.localeCompare(b.name);
																	});
																	combo.items = model.dataField;
																	combo.required = true;
																});																
															},
															placeHolder: 'Select'
														},
														{
															//wrap to make sure the layout works
															tag: 'div',
															children: [
																{
																	tag: 'dl-tagfield',
																	name: 'multipleMapFields',
																	label: 'Multiple Map Fields',
																	helpText: 'Press Enter to create Field',
																	maxLength: 255
																}
															]
														},
														{
															tag: 'dl-section-title',
															title: 'Transforms',
															colspan: 2,
															style: 'margin-top: 20px;'											
														},
														{
															tag: 'div',
															style: 'height: 300px;',
															colspan: 2,
															children: [
																{
																	tag: 'dl-flex-layout',
																	children: [
																		{
																			tag: 'dl-toolbar',
																			slot: 'toolbar',
																			theme: 'spacing',
																			children: [
																				{
																					tag: 'vaadin-button',
																					theme: 'primary',
																					'class': 'spacer-toolbar-item',
																					children: [
																						ElementUtil.makeIcon('vaadin:plus', ' Add')
																					],
																					listeners: {
																						click: function () {
																							actionAddEditTransform();
																						}
																					}
																				},
																				{
																					tag: 'vaadin-button',
																					itemid: 'editTransform',
																					disabled: true,
																					'class': 'spacer-toolbar-item',
																					children: [
																						ElementUtil.makeIcon('vaadin:edit', ' Edit')
																					],
																					listeners: {
																						click: function () {
																							actionAddEditTransform(transformGrid.selectedItems[0]);
																						}
																					}
																				},
																				{
																					tag: 'vaadin-button',
																					itemid: 'removeTransform',
																					disabled: true,
																					theme: 'error primary',
																					'class': 'spacer-toolbar-item',
																					style: 'float: right;',
																					children: [
																						ElementUtil.makeIcon('vaadin:close', ' Remove')
																					],
																					listeners: {
																						click: function () {
																							actionRemoveTransform(transformGrid.selectedItems[0]);
																						}
																					}
																				}
																			]
																		},
																		transformGrid
																	]
																}
															]
														},
														{
															tag: 'dl-section-title',
															title: 'Matchers',
															colspan: 2,
															style: 'margin-top: 20px;'											
														},
														{
															tag: 'div',
															style: 'height: 300px;',
															colspan: 2,
															children: [
																{
																	tag: 'dl-flex-layout',
																	children: [
																		{
																			tag: 'dl-toolbar',
																			slot: 'toolbar',
																			theme: 'spacing',
																			children: [
																				{
																					tag: 'vaadin-button',
																					theme: 'primary',
																					'class': 'spacer-toolbar-item',
																					children: [
																						ElementUtil.makeIcon('vaadin:plus', ' Add')
																					],
																					listeners: {
																						click: function () {
																							actionAddEditMatcher();
																						}
																					}
																				},
																				{
																					tag: 'vaadin-button',
																					disabled: true,
																					itemid: 'editMatcher',
																					'class': 'spacer-toolbar-item',
																					children: [
																						ElementUtil.makeIcon('vaadin:edit', ' Edit')
																					],
																					listeners: {
																						click: function () {
																							actionAddEditMatcher(matcherGrid.selectedItems[0]);
																						}
																					}
																				},
																				{
																					tag: 'vaadin-button',
																					disabled: true,
																					itemid: 'removeMatcher',
																					theme: 'error primary',
																					'class': 'spacer-toolbar-item',
																					style: 'float: right;',
																					children: [
																						ElementUtil.makeIcon('vaadin:close', ' Remove')
																					],
																					listeners: {
																						click: function () {
																							actionRemoveMatcher(matcherGrid.selectedItems[0]);
																						}
																					}
																				}
																			]
																		},
																		matcherGrid
																	]
																}
															]
														},														
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function () {

																			if (formPanel.isValid()) {
																				var data = formPanel.getData();
																				
																				data.transforms = transforms;
																				data.matchers = matchers;
																				
																				if (fieldRecord) {
																					fieldRecord.mapField = data.mapField;
																					fieldRecord.dataField = data.dataField;
																					fieldRecord.multipleMapFields = data.multipleMapFields;
																					fieldRecord.transforms = data.transforms;
																					fieldRecord.matchers = data.matchers;
																				} else {
																					fieldMappings.push(data);
																				}	
																				
																				actionRefreshFields();
																				addEditMappingWin.close();
																			}
																			
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			//cancel
																			addEditMappingWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});

										addEditMappingWin.addToContentElement(formPanel);
										
										var actionRefreshTransforms = function() {
											transformGrid.activeItem = null;
											transformGrid.items = transforms.slice();
										};
										
										var actionAddEditTransform = function(transformRecord) {
											var addEditTransformWin = ElementUtil.create({
												tag: 'dl-dialog',
												title: (transformRecord ? 'Edit' : 'Add') + ' Transform',
												icon: 'vaadin:edit',
												width: .65,
												height: 300,
												listeners: {
													ready: function() {											
														addEditTransformWin.show();
														
														var transformFormPanel = ElementUtil.create({
															tag: 'dl-form-panel',
															itemid: 'form',
															children: [
																{
																	tag: 'vaadin-form-layout',
																	children: [																		
																		{
																			tag: 'vaadin-combo-box',
																			itemid: 'transformCB',
																			name: 'transform',
																			label: 'Transform',
																			'item-value-path': 'transformId',
																			'item-label-path': 'description',																			
																			postinit: function (combo) {
																				DataManagementService.getCustomDataHandlerService().getTransforms().then(function(transforms) {
																					transforms.sort(function (a, b) {
																						return a.description.localeCompare(b.description);
																					});
																					combo.items = transforms;
																					combo.required = true;
																				});
																			},
																			listeners: {
																				'selected-item-changed': function(event) {
																					var item = ElementUtil.query(transformFormPanel, 'transformCB').selectedItem;
																					var optionField = ElementUtil.query(transformFormPanel, 'transformOption');
																					if (item && item.requiresOption) {
																						optionField.disabled = false;
																						optionField.required = true;
																						optionField.helperText = item.optionHelp || item.description || '';
																					} else {
																						optionField.disabled = true;
																						optionField.required = false;
																						optionField.helperText = '';
																					}
																				}
																			},
																			placeHolder: 'Select'
																		},
																		{
																			tag: 'vaadin-number-field',
																			name: 'orderId',
																			label: 'Order Id',
																			required: true,
																			minValue: -999999,
																			maxValue: 999999
																		},
																		{
																			tag: 'vaadin-text-field',
																			itemid: 'transformOption',
																			disabled: true,
																			name: 'transformOption',
																			label: 'Option',
																			maxLength: 255
																		},

																		{
																			tag: 'hr',
																			colspan: 2
																		},
																		{
																			tag: 'div',
																			style: 'text-align: center;',
																			colspan: 2,
																			defaults: {
																				tag: 'vaadin-button'
																			},
																			children: [
																				{
																					theme: 'primary',
																					children: [
																						ElementUtil.makeIcon('vaadin:database', ' Save')
																					],
																					listeners: {
																						click: function () {
																							
																							if (transformFormPanel.isValid()) {
																								var data = transformFormPanel.getData();
																								if (transformRecord) {
																									transformRecord.transform = data.transform;
																									transformRecord.orderId = data.orderId;
																									transformRecord.transformOption = data.transformOption;
																								} else {
																									transforms.push(data);	
																								}																								
																								actionRefreshTransforms();		
																								addEditTransformWin.close();
																							}
																						}
																					}
																				},
																				{
																					theme: 'tertiary',
																					innerHTML: 'Cancel',
																					style: 'margin-left: 10px;',
																					listeners: {
																						click: function () {
																							//cancel
																							addEditTransformWin.close();
																						}
																					}
																				}
																			]
																		}
																	]
																}
															]
														});
														
														addEditTransformWin.addToContentElement(transformFormPanel);
														
														if (transformRecord) {
															transformFormPanel.load(transformRecord);
														}
													}
												}
											});
										};
										
										var actionRemoveTransform = function(transformRecord) {
											var remainingTransforms = [];

											transforms.forEach(function (item) {
												if (transformRecord.transform !== item.transform &&
														transformRecord.orderId !== item.orderId) {
													remainingTransforms.push(item);
												}
											});
											transforms = remainingTransforms;
											actionRefreshTransforms();
										};
										
										var actionRefreshMatcher = function() {
											matcherGrid.activeItem = null;
											matcherGrid.items = matchers.slice();
										};										
										
										var actionAddEditMatcher = function(matcherRecord) {
											var addEditMatchWin = ElementUtil.create({
												tag: 'dl-dialog',
												title: (matcherRecord ? 'Edit' : 'Add') + ' Matcher',
												icon: 'vaadin:edit',
												width: .65,
												height: 300,
												listeners: {
													ready: function() {											
														addEditMatchWin.show();
														
														var matchFormPanel = ElementUtil.create({
															tag: 'dl-form-panel',
															itemid: 'form',
															children: [
																{
																	tag: 'vaadin-form-layout',
																	children: [	
																		{
																			tag: 'vaadin-text-field',
																			itemid: 'sourceValue',
																			required: true,
																			name: 'sourceValue',
																			label: 'Source Value',																			
																			maxLength: 255
																		},
																		{
																			tag: 'vaadin-combo-box',
																			itemid: 'matchTypeCB',
																			name: 'matchType',
																			label: 'Match Type',
																			'item-value-path': 'code',
																			'item-label-path': 'description',
																			required: true,
																			postinit: function (combo) {
																				Service.getLookupService().getLookupValues('CustomDataMatcherType').then(function (data) {
																					combo.items = data;
																				});
																			},																			
																			placeHolder: 'Select'
																		},																		
																		{
																			tag: 'vaadin-text-field',
																			itemid: 'newValue',
																			required: true,
																			name: 'newValue',
																			label: 'New Value',																			
																			maxLength: 255
																		},
																		{
																			tag: 'hr',
																			colspan: 2
																		},
																		{
																			tag: 'div',
																			style: 'text-align: center;',
																			colspan: 2,
																			defaults: {
																				tag: 'vaadin-button'
																			},
																			children: [
																				{
																					theme: 'primary',
																					children: [
																						ElementUtil.makeIcon('vaadin:database', ' Save')
																					],
																					listeners: {
																						click: function () {
																							
																							if (matchFormPanel.isValid()) {
																								var data = matchFormPanel.getData();
																								if (matcherRecord) {
																									matcherRecord.sourceValue = data.sourceValue;
																									matcherRecord.matchType = data.matchType;
																									matcherRecord.newValue = data.newValue;
																								} else {
																									matchers.push(data);	
																								}																								
																								actionRefreshMatcher();		
																								addEditMatchWin.close();
																							}
																						}
																					}
																				},
																				{
																					theme: 'tertiary',
																					innerHTML: 'Cancel',
																					style: 'margin-left: 10px;',
																					listeners: {
																						click: function () {
																							//cancel
																							addEditMatchWin.close();
																						}
																					}
																				}
																			]
																		}
																	]
																}
															]
														});
														
														addEditMatchWin.addToContentElement(matchFormPanel);
														
														if (matcherRecord) {
															matchFormPanel.load(matcherRecord);
														}
													}
												}
											});
										};
										
										var actionRemoveMatcher = function(matcherRecord) {
											var remainingMatcher = [];

											matchers.forEach(function (item) {
												if (matcherRecord.sourceValue !== item.sourceValue) {
													remainingMatcher.push(item);
												}
											});
											matchers = remainingMatcher;
											actionRefreshMatcher();
										};
										
										if (fieldRecord) {
											formPanel.load(fieldRecord);

											if (fieldRecord.transforms) {
												transforms = fieldRecord.transforms.slice();
												actionRefreshTransforms();
											}
											
											if (fieldRecord.matchers) {
												matchers = fieldRecord.matchers.slice();
												actionRefreshMatcher();
											}
											
										}
									}
								}
							});
														
						};
						
						var actionImportFieldMappings = function() {
							//popup upload form							
							//populate the grid
							var uploadWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Import File Fields',
								icon: 'vaadin:upload',
								width: 450,
								height: 220,
								listeners: {
									ready: function () {
										uploadWin.show();

										var uploadHandler = function () {

											var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');

											if (!uploadField.files || uploadField.files.length < 1) {
												window.DL.MessageUtil.showOkMessage('A import file is required.');
											} else {
												uploadField.uploadFiles();
											}

										};

										var uploadFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-upload',
													itemid: 'uploadField',
													'no-auto': true,
													'max-files': 1,
													required: true,
													target: '/api/resource/custom-data-handlers/mapping-fields/' + record.readerType,
													headers: ImportUtil.getUploadHeader(),
													listeners: {
														'upload-request': function (event) {
															//var data = uploadFormPanel.getData();	
															
														},
														'upload-success': function (event) {
															var responseData = JSON.parse(event.detail.xhr.responseText);
															
															responseData.mapFields.forEach(function(field){
																fieldMappings.push({
																	mapField: field.name,
																	note: field.value
																});
															});
																														
															actionRefreshFields();
															uploadWin.close();
														}
													}
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:upload', ' Upload')
																	],
																	listeners: {
																		click: function () {
																			if (uploadFormPanel.isValid()) {
																				uploadHandler();
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			uploadWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});
										uploadWin.addToContentElement(uploadFormPanel);

									}
								}


							});	
							
						};
						
						var actionRemoveFieldMapping = function(toRemoveField) {
							var remainingMappings = [];
							
							fieldMappings.forEach(function(item){
								if (toRemoveField.mapField !== item.mapField &&
									toRemoveField.mapField !== item.dataField) {
									remainingMappings.push(item);
								}						
							});	
							fieldMappings = remainingMappings;
							actionRefreshFields();
						};
						
						var actionSaveMapping = function() {
							
							//check field mappings
							var allMappingHaveDataFields = true;
							fieldMappings.forEach(function(field){
								if (!field.mapField || !field.dataField) {
									allMappingHaveDataFields = false;
								}
							});
							
							if (!allMappingHaveDataFields) {
								
								window.DL.MessageUtil.showConfirm({
									title: 'Validation Error',
									message: 'Map Field(s) and Data Field(s) are required.',
									buttons: [{
										text: 'Ok'										
									}]
								});
								
							} else {							
								record.fields = fieldMappings;							
								record.skipConditions = skipConditions; 
								
								var loadMask = mappingWin.showLoading('Saving...');
								DataManagementService.getCustomDataHandlerService().saveCustomHandler(record, true).then(function(results){
									loadMask.remove();
									
									if (results.success === false) {
										
										var errorMessages = [];
										results.errors.forEach(function(errorObject){
											for (var key in errorObject) {
												errorMessages.push(key + ' - ' + errorObject[key]);
											}											
										});
										
										window.DL.MessageUtil.showToastError(errorMessages.join('<br>'));
										
									} else {									
										window.DL.MessageUtil.showToast('Success', 'Saved Custom Data Handler', {
											theme: 'success',
											position: 'top-stretch'
										});
																	
										mappingWin.close();
										actionRefresh();
									}
								});
								
							}
							
						};
						
						var actionSkipConditions = function() {							
							var skipWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Skip Conditions',
								icon: 'vaadin:minus',
								width: .70,
								height: .70,
								listeners: {
									ready: function() {
										skipWin.show();
										
										var skipToolbar = ElementUtil.create({
											tag: 'dl-toolbar',
											slot: 'toolbar',
											theme: 'spacing',
											children: [
												{
													tag: 'vaadin-button',
													itemid: 'add',
													theme: 'primary',
													'class': 'spacer-toolbar-item',
													children: [
														ElementUtil.makeIcon('vaadin:plus', ' Add')
													],
													listeners: {
														click: function () {
															actionAddEditSkip();
														}
													}
												},
												{
													tag: 'vaadin-button',
													itemid: 'edit',
													disabled: true,
													'class': 'spacer-toolbar-item',
													children: [
														ElementUtil.makeIcon('vaadin:edit', ' Edit')
													],
													listeners: {
														click: function () {
															actionAddEditSkip(skipGrid.selectedItems[0]);
														}
													}
												},																								
												{
													tag: 'div',
													style: 'float: right;',
													children: [
														{
															tag: 'vaadin-button',
															theme: 'error primary',
															itemid: 'remove',
															disabled: true,
															'class': 'spacer-toolbar-item',
															style: 'float: right;',
															children: [
																ElementUtil.makeIcon('vaadin:trash', ' Remove')
															],
															listeners: {
																click: function () {
																	actionRemoveSkip(skipGrid.selectedItems[0]);
																}
															}
														}
													]
												}
											]
										});

										var skipGrid = ElementUtil.create({
											tag: 'vaadin-grid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},
											children: [
												{
													path: 'mapField',
													header: 'Map Field',
													width: '9em'
												},
												{
													path: 'matchType',
													header: 'Match Type',
													width: '7em'
												},
												{
													path: 'matchValue',
													header: 'Match Value',
													width: '9em'
												}
											],
											listeners: {
												'active-item-changed': function (event) {
													const item = event.detail.value;
													skipGrid.selectedItems = item ? [item] : [];
													if (skipGrid.selectedItems.length > 0) {
														ElementUtil.query(skipToolbar, 'edit').disabled = false;
														ElementUtil.query(skipToolbar, 'remove').disabled = false;
													} else {
														ElementUtil.query(skipToolbar, 'edit').disabled = true;
														ElementUtil.query(skipToolbar, 'remove').disabled = true;
													}
												}
											}
										});
										
										var skipFooterToolbar = ElementUtil.create({
											tag: 'dl-toolbar',
											slot: 'footer',
											theme: 'spacing',
											children: [
												{
													tag: 'div',
													style: 'text-align: center;',
													defaults: {
														tag: 'vaadin-button'
													},
													children: [
														{
															theme: 'primary',
															children: [
																ElementUtil.makeIcon('vaadin:check', ' Done')
															],
															listeners: {
																click: function () {
																	skipWin.close();
																}
															}
														}
													]
												}
											]
										});
										
										var flexLayoutSkip = ElementUtil.create({
											tag: 'dl-flex-layout',
											children: [
												skipToolbar,
												skipGrid,
												skipFooterToolbar
											]
										});
										
										skipWin.addToContentElement(flexLayoutSkip);

										var activeRefreshSkips = function() {
											skipGrid.activeItem = null;
											skipGrid.items = skipConditions.slice();	
										};
										activeRefreshSkips();
										
										var actionAddEditSkip = function(skipRecord) {
											var addEditSkipWin = ElementUtil.create({
												tag: 'dl-dialog',
												title: (skipRecord ? 'Edit' : 'Add') + ' Skip',
												icon: 'vaadin:minus',
												width: 400,
												height: 350,
												listeners: {
													ready: function() {
														addEditSkipWin.show();
														
														var skipFormPanel = ElementUtil.create({
															tag: 'dl-form-panel',
															itemid: 'form',
															children: [
																{
																	tag: 'vaadin-form-layout',
																	children: [	
																		{
																			tag: 'vaadin-text-field',
																			itemid: 'mapField',
																			required: true,
																			name: 'mapField',
																			label: 'Map Field',
																			placeholder: 'e.g. COLUMN-1',
																			helper: 'CSV/TSV columns are COLUMN-1, COLUMN-2, ... (case-insensitive)',
																			maxLength: 255
																		},
																		{
																			tag: 'vaadin-combo-box',
																			itemid: 'matchTypeCB',
																			name: 'matchType',
																			label: 'Match Type',
																			'item-value-path': 'code',
																			'item-label-path': 'description',																			
																			postinit: function (combo) {
																				Service.getLookupService().getLookupValues('CustomDataMatcherType').then(function (data) {
																					combo.items = data;
																					combo.required = true;
																				});
																			},																			
																			placeHolder: 'Select'
																		},																		
																		{
																			tag: 'vaadin-text-field',
																			itemid: 'matchValue',
																			required: true,
																			name: 'matchValue',
																			label: 'Match Value',																			
																			maxLength: 255
																		},
																		{
																			tag: 'hr',
																			colspan: 2
																		},
																		{
																			tag: 'div',
																			style: 'text-align: center;',
																			colspan: 2,
																			defaults: {
																				tag: 'vaadin-button'
																			},
																			children: [
																				{
																					theme: 'primary',
																					children: [
																						ElementUtil.makeIcon('vaadin:database', ' Save')
																					],
																					listeners: {
																						click: function () {
																							
																							if (skipFormPanel.isValid()) {
																								var data = skipFormPanel.getData();
																								if (skipRecord) {
																									skipRecord.mapField = data.mapField;
																									skipRecord.matchType = data.matchType;
																									skipRecord.matchValue = data.matchValue;
																								} else {
																									skipConditions.push(data);	
																								}																								
																								activeRefreshSkips();		
																								addEditSkipWin.close();
																							}
																						}
																					}
																				},
																				{
																					theme: 'tertiary',
																					innerHTML: 'Cancel',
																					style: 'margin-left: 10px;',
																					listeners: {
																						click: function () {
																							//cancel
																							addEditSkipWin.close();
																						}
																					}
																				}
																			]
																		}
																	]
																}
															]
														});
														
														addEditSkipWin.addToContentElement(skipFormPanel);
														
														if (skipRecord) {
															skipFormPanel.load(skipRecord);
														}
														
													}
												}
											});
											
										};
										
										var actionRemoveSkip = function(skipRecord) {
											var remainingSkip = [];

											skipConditions.forEach(function (item) {
												if (item !== skipRecord) {
													remainingSkip.push(item);
												}
											});
											skipConditions = remainingSkip;
											activeRefreshSkips();
										};

									}
								}
							});							
						};
						
						if (record) {
							//load field
							if (record.fields) {
								fieldMappings = record.fields.slice();
							}
							actionRefreshFields();
							
							//load skips
							if (record.skipConditions) {
								skipConditions = record.skipConditions.slice();								
							}
						}
						
					}
				}
			});
			
		};	
		
		var actionTest = function(record) {
	
			var testWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Test: ' + record.name + " - " + record.dataTypeDescription + " - " + record.readerTypeDescription,
				icon: 'vaadin:play',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						testWin.show();
					
						var uploadHandler = function () {

							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');

							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A import file is required.');
							} else {
								uploadField.uploadFiles();
							}

						};

						var uploadFormPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							slot: 'toolbar',
							children: [
								{
									tag: 'vaadin-upload',
									itemid: 'uploadField',
									'no-auto': true,
									'max-files': 1,
									required: true,
									target: '/api/resource/custom-data-handlers/sample-process/' + record.customHandlerId,
									headers: ImportUtil.getUploadHeader(),
									listeners: {
										'upload-request': function (event) {
											//var data = uploadFormPanel.getData();	

										},
										'upload-success': function (event) {
											var responseData = JSON.parse(event.detail.xhr.responseText);
																						
											ElementUtil.removeAllChildren(recordsDisplay);

											var setAllRecordPanelsExpanded = function (expanded) {
												Array.from(recordsDisplay.querySelectorAll('dl-section-panel')).forEach(function (panel) {
													var header = panel.querySelector('dl-section-title');
													if (!header || !header.collapse || !header.expand) {
														return;
													}
													if (expanded) {
														if (!header.open) {
															header.expand();
														}
													} else if (header.open) {
														header.collapse();
													}
												});
											};

											recordsDisplay.append(ElementUtil.create({
												tag: 'dl-toolbar',
												theme: 'spacing',
												style: 'padding: 4px 8px;',
												children: [
													{
														tag: 'vaadin-button',
														theme: 'tertiary',
														children: [
															ElementUtil.makeIcon('vaadin:angle-down', ' Expand All')
														],
														listeners: {
															click: function () {
																setAllRecordPanelsExpanded(true);
															}
														}
													},
													{
														tag: 'vaadin-button',
														theme: 'tertiary',
														children: [
															ElementUtil.makeIcon('vaadin:angle-up', ' Collapse All')
														],
														listeners: {
															click: function () {
																setAllRecordPanelsExpanded(false);
															}
														}
													}
												]
											}));
											
											var count = 1;
											(responseData.data || []).forEach(function(item) {
												var itemRecord = [];
												var flatten = ElementUtil.objToDotNotation(item);
												for (var key in flatten) {
													if (!key.includes('mappableFields') && !key.includes('availableFilterFields')) {
														itemRecord.push({
															key: key,
															value: flatten[key]
														});
													}
												}
												itemRecord.sort(function(a, b){
													return a.key.localeCompare(b.key);
												});

												var detailTable = ElementUtil.create({
													tag: 'dl-detail-table',
													slot: 'content'
												});
												var recordPanel = ElementUtil.create({
													tag: 'dl-section-panel',
													title: 'Record ' + (count++),
													collapsible: true,
													collapeAtFirst: true,
													style: 'margin: 6px 8px;',
													children: [
														detailTable
													]
												});
												recordsDisplay.append(recordPanel);
												detailTable.updateDetails(itemRecord);
											});

										}
									}
								},								
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:upload', ' Upload')
													],
													listeners: {
														click: function () {
															if (uploadFormPanel.isValid()) {
																uploadHandler();
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															testWin.close();
														}
													}
												}
											]
										}
									]
								},
								{
									tag: 'dl-section-title',
									title: 'Results',
									colspan: 2,
									style: 'margin-top: 10px;'	
								}
							]
						});
						
						var recordsDisplay = ElementUtil.create({
							tag: 'div',
							slot: 'primary',
							style: 'border: 1px solid lightgrey; overflow: auto;'							
						});
						
						var flexLayoutTest = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								uploadFormPanel,
								recordsDisplay
							]
						});

						testWin.addToContentElement(flexLayoutTest);
						
					}
				}
			});
			
		};	
		
	}
	
}
customElements.define('dl-customhandler-grid', CustomHandlerGrid);
